import { useEffect } from "react";
import { SITE_URL } from "@/data/site";

const upsert = (selector, make) => {
    let el = document.head.querySelector(selector);
    if (!el) {
        el = make();
        document.head.appendChild(el);
    }
    return el;
};

export const Seo = ({ title, description, path, ogImage = "/images/og-home.jpg", jsonLd }) => {
    useEffect(() => {
        document.title = title;
        const url = `${SITE_URL}${path}`;
        const image = `${SITE_URL}${ogImage}`;

        upsert('meta[name="description"]', () => {
            const m = document.createElement("meta");
            m.setAttribute("name", "description");
            return m;
        }).setAttribute("content", description);

        upsert('link[rel="canonical"]', () => {
            const l = document.createElement("link");
            l.setAttribute("rel", "canonical");
            return l;
        }).setAttribute("href", url);

        const og = {
            "og:title": title,
            "og:description": description,
            "og:url": url,
            "og:image": image,
            "og:type": "website",
            "og:site_name": "AXORA PS GLOBAL LLP",
        };
        Object.entries(og).forEach(([property, value]) => {
            upsert(`meta[property="${property}"]`, () => {
                const m = document.createElement("meta");
                m.setAttribute("property", property);
                return m;
            }).setAttribute("content", value);
        });

        const twitter = {
            "twitter:card": "summary_large_image",
            "twitter:title": title,
            "twitter:description": description,
            "twitter:image": image,
        };
        Object.entries(twitter).forEach(([name, value]) => {
            upsert(`meta[name="${name}"]`, () => {
                const m = document.createElement("meta");
                m.setAttribute("name", name);
                return m;
            }).setAttribute("content", value);
        });

        let ld = document.getElementById("page-jsonld");
        if (jsonLd) {
            if (!ld) {
                ld = document.createElement("script");
                ld.id = "page-jsonld";
                ld.type = "application/ld+json";
                document.head.appendChild(ld);
            }
            ld.textContent = JSON.stringify(jsonLd);
        } else if (ld) {
            ld.remove();
        }
    }, [title, description, path, ogImage, jsonLd]);

    return null;
};
